import { cwslapi } from "../index";

// 获取日常任务列表
export const getTaskListApi = (data) => { 
  return cwslapi({
    url: "/task/getTaskList",
    method: "post",
    data,
  });
};


// 领取任务奖励 - 任务管理
export const getTaskPrizeApi = (data) => { 
  return cwslapi({
    url: "/task/getTaskPrize",
    method: "post",
    data,
  });
};